import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function OpenBoard(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, sx, viewBox, "data-tidal": "TidalIllustration", "data-tidal-illustration": "OpenBoard", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.primary.dark,
        d: "M6 27.75a.751.751 0 0 1-.607-1.19L19.764 6.704a5.35 5.35 0 0 1 8.309-.427L44.809 25a.75.75 0 0 1-1.118 1L26.956 7.274a3.85 3.85 0 0 0-5.977.307L6.609 27.439A.75.75 0 0 1 6 27.75Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: theme.vars.palette.primary.light, d: "M24 9.75a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.primary.light,
        d: "m43.06 40.253-37.5 3.98a3.03 3.03 0 0 1-3.31-3.058V25.811a3.051 3.051 0 0 1 2.691-3.063l37.5-3.981a3.033 3.033 0 0 1 3.31 3.062v15.36a3.05 3.05 0 0 1-2.692 3.064Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.secondary.main,
        d: "M39.75 23.25A.75.75 0 0 0 39 24v11.152a.101.101 0 0 1-.194.024l-2.663-9.989a1.598 1.598 0 0 0-3.143.411V36.75a.75.75 0 1 0 1.5 0V25.598a.101.101 0 0 1 .194-.024l2.663 9.989a1.598 1.598 0 0 0 3.143-.411V24a.75.75 0 0 0-.75-.75Zm-8.877 8.24a.75.75 0 0 0-.246-1.48L27 30.616v-3.8a.77.77 0 0 1 .63-.773l3.246-.553a.75.75 0 1 0-.252-1.478l-3.247.553a2.266 2.266 0 0 0-1.875 2.25v9.15a2.291 2.291 0 0 0 .812 1.755 2.213 2.213 0 0 0 1.811.496l2.753-.469a.75.75 0 0 0-.252-1.478l-2.753.468a.729.729 0 0 1-.593-.163.798.798 0 0 1-.28-.606v-3.832l3.873-.645Zm-9.404-6.723-3 .381a2.273 2.273 0 0 0-1.969 2.257V38.25a.75.75 0 1 0 1.5 0v-5.512l4.299-1.088A2.268 2.268 0 0 0 24 29.441v-2.417a2.283 2.283 0 0 0-.771-1.714 2.243 2.243 0 0 0-1.76-.543Zm1.031 4.674a.768.768 0 0 1-.57.75l-3.93 1v-3.786a.767.767 0 0 1 .659-.768l3-.381a.725.725 0 0 1 .576.18.773.773 0 0 1 .263.588l.002 2.417Zm-10.026-3.174-3 .365a2.225 2.225 0 0 0-1.974 2.19v8.72a2.19 2.19 0 0 0 .742 1.639 2.276 2.276 0 0 0 1.785.553l3-.365A2.225 2.225 0 0 0 15 37.179v-8.722a2.19 2.19 0 0 0-.742-1.638 2.29 2.29 0 0 0-1.784-.552ZM13.5 37.178a.724.724 0 0 1-.654.702l-3 .364a.788.788 0 0 1-.609-.186.686.686 0 0 1-.237-.515v-8.721a.724.724 0 0 1 .654-.701l3-.365a.776.776 0 0 1 .608.186.687.687 0 0 1 .236.515l.002 8.721Z"
      }
    )
  ] });
}
OpenBoard.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "OpenBoard"
};
validateTidalLicense();
export {
  OpenBoard
};
//# sourceMappingURL=OpenBoard.js.map
